export const SETTINGS_DRAWERS = {
  BUSINESS_HOURS: 'businessHoursDrawer',
  CONTENT_AUTOMATION: 'contentAutomationDrawer',
  INSTALLATION_GUIDE: 'installationGuideDrawer',
  PERFORMANCE_ALERT: 'performanceAlertDrawer',
};
